// Billing-period math. A period is defined by a start day-of-month (1-31).
// The period runs from the most recent occurrence of that day through the day
// before the next occurrence, yielding ~28-31 days depending on the month.
// Short-month handling: a start day of 31 in a 30-day month falls back to day 30.

function lastDayOfMonth(year, monthIdx) {
  return new Date(year, monthIdx + 1, 0).getDate();
}

function normalizeDay(year, monthIdx, startDay) {
  return Math.min(startDay, lastDayOfMonth(year, monthIdx));
}

export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

function addDays(d, n) {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

// Given startDay (1-31) and a reference date, return the period containing it.
export function getBillingPeriod(startDay, referenceDate = new Date()) {
  const y = referenceDate.getFullYear();
  const m = referenceDate.getMonth();
  const d = referenceDate.getDate();

  const thisMonthStart = normalizeDay(y, m, startDay);

  let startDate;
  if (d >= thisMonthStart) {
    startDate = new Date(y, m, thisMonthStart);
  } else {
    const prevY = m === 0 ? y - 1 : y;
    const prevM = m === 0 ? 11 : m - 1;
    startDate = new Date(prevY, prevM, normalizeDay(prevY, prevM, startDay));
  }

  const nextY = startDate.getMonth() === 11 ? startDate.getFullYear() + 1 : startDate.getFullYear();
  const nextM = startDate.getMonth() === 11 ? 0 : startDate.getMonth() + 1;
  const nextStart = new Date(nextY, nextM, normalizeDay(nextY, nextM, startDay));
  const endDate = addDays(nextStart, -1);

  return {
    start: startDate,
    end: endDate,
    startISO: toISO(startDate),
    endISO: toISO(endDate),
    lengthDays: Math.round((endDate - startDate) / 86400000) + 1,
  };
}

export function datesBetween(startISO, endISO) {
  const out = [];
  const cur = new Date(startISO + 'T00:00:00');
  const end = new Date(endISO + 'T00:00:00');
  while (cur <= end) {
    out.push(toISO(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return out;
}

export function daysElapsed(period, today = new Date()) {
  const ref = new Date(toISO(today) + 'T00:00:00');
  if (ref < period.start) return 0;
  if (ref > period.end) return period.lengthDays;
  return Math.round((ref - period.start) / 86400000) + 1;
}

export function todayISO() {
  return toISO(new Date());
}
